import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import { vocabularies as vocabulariesJP } from "./translations/jp";

const resources = {
  ja: {
    translation: vocabulariesJP,
  },
};

i18next.use(initReactI18next).init({ resources, lng: "ja" });

export default i18next;
